import { useMutation, useQueryClient } from 'react-query';
import { User } from '~types/api/user';
import { useUserStore } from '~providers/userStore/zustand';
import { apiService } from '~services/ApiService';
export function useUpdateUser() {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    async (userData: Partial<User>) => {
      const userId = useUserStore.getState().user?.uid;

      if (!userId) {
        throw new Error('User ID not found');
      }

      const updateData = { ...userData, uid: userId };
      return await apiService.patch<User>(`users/${userId}`, updateData);
    },
    { onSuccess: () => queryClient.refetchQueries(['userAccount']) },
  );

  return mutation;
}
